const customMedia = (width: number) => `@media screen and (min-width: ${width}px)`;

const desktopSmartPhones = 424;
export const desktopBreakpoint = 900;
export const mediaSmartPhones = customMedia(desktopSmartPhones);
export const mediaDesktop = customMedia(desktopBreakpoint);
